import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { environment } from '../../environment/environment';
import { Delibera } from '../../model/delibere-data';
import { GruppoValore, ListaProvvisoriDto, ProvvisorioDettaglioListaDto } from '../../model/iscritti-data';
import { IscrittiService } from '../../services/iscritti.service';
import { DialogDeliberaComponent } from '../dialog-delibera/dialog-delibera.component';
import { PrintService } from '../../services/print.service';
import { RoleService } from '../../services/role.service';
import { CustomFiltersService } from '../../services/custom-filters.service';
import { SearchFilters, TableSettings } from '../../model/filters-data';
import { DeliberaService } from '../../services/delibera.service';

@Component({
  selector: 'app-tabella-provvisori-finalizzare',
  templateUrl: './tabella-provvisori-finalizzare.component.html',
  styleUrl: './tabella-provvisori-finalizzare.component.scss'
})
export class TabellaProvvisoriFinalizzareComponent implements OnInit {

  @ViewChild('dt') dt!: Table;

  resetFlag: boolean = false;
  initialFlagHandler: boolean = true;
  xlsSpinner: boolean = false;

  // prova per la gestione della regione per i componenti
  regione = environment.regione;

  //dialog dati
  ref: DynamicDialogRef | undefined;

  //services
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private iscritti_service = inject(IscrittiService);
  private dialog_service = inject(DialogService);
  private message_service = inject(MessageService);
  private print_service = inject(PrintService);
  private custom_filters_service = inject(CustomFiltersService);
  public role_service = inject(RoleService);
  private delibera_service = inject(DeliberaService);

  //gestione del componente
  tipoLista: string = '';
  componente: string = '';
  sezione: string = '';
  deliberaCorrente: Delibera | undefined;

  keyDataCheckbox = "codiceFiscale";
  provvisoriSelezionati: ProvvisorioDettaglioListaDto[] = [];

  //filtro generale per tutti i tipi di tabella
  filtri = new FormGroup({
    inserimento: new FormControl<string|null>('')
  })

  sezioniOptions: GruppoValore[] = [
    { nome: 'Sezione A', valore: 'A' },
    { nome: 'Sezione B', valore: 'B' }
  ]

  //dati della tabella
  headersTabella: string[] = ['Codice Fiscale', 'Data Domanda', 'Nome', 'Cognome', 'Sezione', 'N° Iscrizione', 'Bozza Riepilogo', 'Pec']
  rowsTabella: string[] = ['codiceFiscale', 'domandaData', 'nome', 'cognome', 'sezioneAlbo', 'numeroIscrizione', 'numeroDelibera', 'pec']
  listaProvvisori: ProvvisorioDettaglioListaDto[] = [];

  dettaglioIscrittoRoute = '/gestione_albo/gestione_iscritti/dettaglio_iscritto/';

  orderColumnName: string = '';
  order: string = 'ASC';
  page: number = 0;
  pageSize: number = 25;
  currentPage: number = 0;

  totaleDati: number = 0;


  ngOnInit(): void {

    this.initialDataHandler(); //gestisce i dati iniziali

    this.filtri.valueChanges.subscribe(() => { //gestione sul cambio filtri
      this.resetPagination();
      this.loadData();
    })

  }


  //gestione dei dati iniziali
  private initialDataHandler(){

    const componente: string = this.route.snapshot.data['componente'];
    const iscritti: ListaProvvisoriDto = this.route.snapshot.data[componente];
    this.deliberaCorrente = this.route.snapshot.data['delibera'];
    this.sezione = componente === 'provvisori_b_finalizza' ? 'B' : 'A';

    this.componente = componente;

    this.listaProvvisori = iscritti.lista;
    this.totaleDati = iscritti.conteggio;
    this.tipoLista = componente;

    this.provvisoriSelezionati = this.listaProvvisori.filter((provvisorio: ProvvisorioDettaglioListaDto) => provvisorio.numeroDelibera !== null && provvisorio.numeroDelibera === this.deliberaCorrente?.numeroDelibera)

    this.inizializzaFiltri();

  }

  //gestisce il caricamento della tabella quando siamo sul componente
  private loadData(){

    const values = this.filtri.value;

     const tabData: TableSettings = {
      orderColumnName: this.orderColumnName,
      order: this.order,
      page: this.page,
      pageSize: this.pageSize,
      currentPage: this.currentPage
    }

    const data: SearchFilters = this.custom_filters_service.sessionStorageUpdate(values, this.componente, tabData);

    this.iscritti_service.getProvvisoriDelibera(data, this.deliberaCorrente?.id!).subscribe({
      next: (result: ListaProvvisoriDto) => {
        this.listaProvvisori = result.lista;
        this.totaleDati = result.conteggio;
      },
      error: (error) => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Operazione interrotta.' });
      }
    })
  }

  //resertta paginazione
  resetPagination(){
    this.orderColumnName = 'codiceFiscale';
    this.order = 'ASC';
    this.pageSize = 25;
    this.page = 0;
    this.currentPage = 0;
  }

  //crea il RouterLink per le voci della tabella
  generaRoutingLink(iscritto: any): string{
    return this.dettaglioIscrittoRoute + iscritto.id;
  }

  //cambio pagina della tabella
  pageChange(event: any){
    this.currentPage = event.first;
    this.page = event.page;
    this.pageSize = event.rows;

    this.loadData();
  }

  ordinamento(event: any){

    if(this.initialFlagHandler){
      this.initialFlagHandler = false;
      return;
    }

    this.orderColumnName = event.sortField ? event.sortField : 'codiceFiscale';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.pageSize = 25;
    this.page = 0;
    this.currentPage = 0;

    if(this.resetFlag){
      this.resetFlag = false;
      this.dt.reset();
      return;
    }

    //if(event.sortOrder === -1) this.resetFlag = true;

    this.loadData();
  }

  //resetta i lbox di ricerca
  resetBoxRicerca(){
    this.filtri.get('inserimento')?.setValue('')
  }

  //resetta i filtri di ricerca
  clearFilters(){

    this.resetPagination();

    this.filtri.patchValue({
      inserimento: ''
    })

    this.dt.reset();

    this.loadData();

  }

  //inizializza i filtri sul routing
  inizializzaFiltri(){

    const sessionData = JSON.parse(sessionStorage.getItem('data')!)[this.componente];

    const str: string = sessionData.inserimento;

    this.filtri.patchValue({
      inserimento: str
    });

    this.orderColumnName = sessionData.orderColumn;
    this.order = sessionData.order;
    this.currentPage = Number(sessionData.currentPage);
    this.page = Number(sessionData.page);
    this.pageSize = Number(sessionData.pageSize);

    const tabData: TableSettings = {
      orderColumnName: this.orderColumnName,
      order: this.order,
      page: this.page,
      pageSize: this.pageSize,
      currentPage: this.currentPage
    }

    this.custom_filters_service.sessionStorageUpdate(this.filtri.value, this.componente, tabData);

  }

  //gestisce il dialog delle delibere
  gestisciDeliberaDialog(operazione: string){
    this.ref = this.dialog_service.open(DialogDeliberaComponent, {
      data: {
        id: this.deliberaCorrente!.id,
        numeroDelibera: this.deliberaCorrente!.numeroDelibera,
        dataDelibera: this.deliberaCorrente!.dataDelibera,
        operazione: operazione
      },
      header: `${operazione} Riepilogo`
    });
    this.ref.onClose.subscribe({
      next: (result) => {
        if(result){
          if(result.messaggio){
            this.message_service.add({
              life: 2000,
              severity: 'error',
              summary: 'Qualcosa è andato storto',
              detail: result.messaggio
            });
            this.router.navigate(['/delibere/gestione']);
          }
          else{
            this.message_service.add({
              severity: 'success',
              summary: `Operazione completata`,
              detail: `Riepilogo approvato con successo.`
            });
            setTimeout(() => {
              this.router.navigate(['/delibere/chiuse']);
            }, 1000)
          }
        }
      },
      error: () => {
        this.message_service.add({
          severity: 'error',
          summary: 'Qualcosa è andato storto',
          detail: 'Operazione interrotta.'
        });
      }
    })
  }

  //checkbox stop propagazione
  impedisciPropagazione(event: Event){
    event.stopPropagation();
  }

  iscrittoNonSelezionabile(iscritto: ProvvisorioDettaglioListaDto): boolean{

    if((!this.deliberaCorrente?.stampa && iscritto.numeroDelibera) || this.deliberaCorrente?.stampa){
      if(iscritto.numeroDelibera !== this.deliberaCorrente!.numeroDelibera) return false;
    }

    return true
  }

  mandaInStampa(){

    const psi: boolean = this.deliberaCorrente?.tipo.codice === 'P';

    const idDelibera = this.deliberaCorrente?.id;
    const sezioneDelibera = this.deliberaCorrente?.tipo;

    this.print_service.stampaIscrizione(idDelibera!, sezioneDelibera?.codice.toLowerCase()!, psi).subscribe({
      next: result => {
        const blob = new Blob([result], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        //window.open(url);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.nomeStampa(psi);
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: err => {
        console.log(err.error);
      }
    })
  }

  nomeStampa(psi: boolean){
    if(this.deliberaCorrente?.tipo.codice === 'T')
      return 'riepilogo_trasferimento.pdf';
    else if(this.deliberaCorrente?.tipo.codice === 'C')
      return 'riepilogo_cambio_sezione.pdf';
    else
      return psi ? 'riepilogo_iscrizione_psicoterapeuti.pdf' : `riepilogo_iscrizione_sezione_${this.sezione.toLowerCase()}.pdf`;
  }

  printIscrittiXLS(){
    this.xlsSpinner = true;

    this.delibera_service.esporta(this.deliberaCorrente?.id!).subscribe({
      next: blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'da_finalizzare_delibera_' + this.deliberaCorrente?.id + '.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
  
        this.xlsSpinner = false;
      },
      error: err => {
        this.message_service.add({
          severity: 'error',
          summary: 'Qualcosa è andato storto',
          detail: 'Operazione interrotta.'
        });
        console.error('Error downloading the file', err);
        this.xlsSpinner = false;
      }
    });
  }

  orderCustom(order: string): number{

    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;

    return check;
  }

}
